import { defaultFormat } from "utils/date"

export const createDateColumn = (title: string, dataIndex: string, width = 180) => ({
  title,
  key: dataIndex,
  dataIndex,
  width,
  render: (date: Date) => defaultFormat(new Date(date)),
})
